/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Liability_1Inputs */

const da_terms_liability_1 = /** @type {(inputs: Terms_Liability_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi gør vores bedste for, at tjenesten er tilgængelig og korrekt, men giver ingen garanti for, at AI-forslag er rigtige. Vi er ikke ansvarlige for indirekte tab, og vores samlede ansvar er begrænset til det beløb, du har betalt de seneste 12 måneder.`)
};

/** @type {(inputs: Terms_Liability_1Inputs) => LocalizedString} */
const en_terms_liability_1 = da_terms_liability_1;

/**

* @param {Terms_Liability_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_liability_1 = /** @type {((inputs?: Terms_Liability_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Liability_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_liability_1(inputs)
	return /** @type {LocalizedString} */ ("Vi gør vores bedste for, at tjenesten er tilgængelig og korrekt, men giver ingen garanti for, at AI-forslag er rigtige. Vi er ikke ansvarlige for indirekte tab, og vores samlede ansvar er begrænset til det beløb, du har betalt de seneste 12 måneder.")
});